import { createFileRoute } from "@tanstack/react-router";
import { Settings } from "lucide-react";
import { SettingsManager } from "@/features/settings";

export const Route = createFileRoute("/_app/parametres")({
  staticData: {
    title: "Paramètres",
    section: "Général",
    order: 99,
    showInTab: false,
    showInBreadcrumb: true,
    icon: Settings,
  },
  component: ParametresPage,
});

function ParametresPage() {
  return <SettingsManager />;
}
